/*
  VentiLum — chargement des vidéos de section.

  Constat mesuré le 2026-07-09 sur la fiche produit : 7 vidéos, 32,4 Mo
  téléchargés au chargement, dont 3 en autoplay alors qu'elles étaient
  invisibles, tout en bas de page. Aucune n'était en lecture.

  Depuis, une vidéo marquée data-vl-lazy-video ne télécharge rien tant qu'elle
  n'approche pas de l'écran. Ses <source> portent data-src ; on ne les recopie
  qu'au dernier moment.

  --- 2026-07-10 : la vidéo se faisait quand même attendre à l'écran.

  1. preload="none" restait sur la balise après l'injection des src. Le
     navigateur obéissait au hint et ne mettait rien en tampon avant le play() :
     le « préchargement » à l'approche de l'écran ne préchargeait rien du tout.
     On repasse donc preload à "auto" avant load(). C'est le correctif principal
     (attente mesurée sur la fiche produit : 755 ms -> 11 ms).

  2. La marge d'anticipation ne couvrait que la verticale, alors que le
     carrousel de vl-videos fait défiler ses cartes horizontalement : la carte
     suivante ne commençait à se charger qu'une fois amenée à l'écran.

  Note sur le HLS. Shopify sert deux sources par vidéo : un flux .m3u8 (1080p /
  720p / 480p) et un seul MP4, à la qualité d'origine. Chrome, Safari et Edge
  lisent le .m3u8 nativement et adaptent la qualité au débit : c'est la première
  <source>, donc c'est elle qui est prise. Le gros MP4 ne sert que de repli, pour
  Firefox. Mesuré le 2026-07-10 : aucun MP4 1080p n'est téléchargé sur Chrome.
  Inutile d'embarquer hls.js, le navigateur fait déjà le travail.

  Comme la marge est large, plusieurs vidéos peuvent devenir candidates en même
  temps. On n'en prépare que deux à la fois : au-delà, elles se volent la bande
  passante et la première visible arrive plus tard qu'avant.

  Une seule vidéo joue à la fois par section visible : les autres sont mises en
  pause, ce qui libère le décodeur et évite les saccades au défilement.
*/
(function () {
  // Le script est inclus par chaque section qui contient une vidéo. En defer,
  // tout le DOM est là dès le premier passage : les suivants créeraient des
  // observateurs en double, donc des lectures et des pauses jouées deux fois.
  if (window.vlLazyVideoActif) return;
  window.vlLazyVideoActif = true;

  var videos = document.querySelectorAll('video[data-vl-lazy-video]');
  if (!videos.length) return;

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var MAX_PARALLELE = 2;
  var enCours = 0;
  var file = [];

  function vidanger() {
    while (enCours < MAX_PARALLELE && file.length) charger(file.shift());
  }

  // Rend son tour à la file dès qu'une image est disponible.
  function surveiller(video) {
    var rendu = false;
    var libere = function () {
      if (rendu) return;
      rendu = true;
      enCours--;
      vidanger();
    };
    video.addEventListener('loadeddata', libere, { once: true });
    video.addEventListener('error', libere, { once: true });
    setTimeout(libere, 6000); // fichier lent, ou événement jamais émis
  }

  function charger(video) {
    if (video.dataset.vlCharge) return;
    video.dataset.vlCharge = '1';

    afficherApercu(video);
    enCours++;
    surveiller(video);

    // Sans ça, load() reconstruit la balise mais ne remplit aucun tampon.
    video.preload = 'auto';
    video.querySelectorAll('source[data-src]').forEach(function (s) {
      s.src = s.dataset.src;
      s.removeAttribute('data-src');
    });
    video.load();
  }

  // L'image d'aperçu, posée dès l'anticipation. Quelques dizaines de Ko : elle
  // arrive bien avant la vidéo, donc la section n'est jamais vide au moment où
  // on la découvre. Dans le HTML elle attend dans data-poster, sinon le
  // navigateur télécharge les 7 posters de la page au chargement et vole la
  // bande passante au streaming (mesuré : lecture retardée de 0,7 s à 2,8 s).
  function afficherApercu(video) {
    var src = video.dataset.poster;
    if (!src || video.getAttribute('poster')) return;
    video.setAttribute('poster', src);
  }

  // Anticipation : l'aperçu s'affiche, la vidéo prend son tour dans la file.
  function planifier(video) {
    afficherApercu(video);
    if (video.dataset.vlCharge || file.indexOf(video) > -1) return;
    file.push(video);
    vidanger();
  }

  // Lecture imminente : elle passe devant tout le monde.
  function jouer(video) {
    var place = file.indexOf(video);
    if (place > -1) file.splice(place, 1);
    charger(video);
    if (reduced) return;
    var p = video.play();
    if (p && p.catch) p.catch(function () {});
  }

  // Sans IntersectionObserver, on charge tout : mieux vaut lourd que cassé.
  if (!('IntersectionObserver' in window)) {
    videos.forEach(charger);
    return;
  }

  // Verticale : un peu plus d'un demi-écran d'avance. Assez pour absorber le
  // défilement, pas assez pour mettre en file les vidéos du bas de page :
  // mesuré le 2026-07-10, une marge de 1200px faisait précharger le carrousel
  // du bas pendant qu'on regardait le haut, et la vidéo visible attendait 9 s.
  //
  // Horizontale : la carte suivante du carrousel, avant qu'on la fasse venir.
  // On la borne à la largeur de l'écran, sinon un téléphone (cartes de ~300px)
  // en prépare trois d'un coup.
  //
  // Sur mobile, 600px de marge verticale valent 70% de l'écran : la home y
  // préparait une vidéo de plus, soit 2,7 Mo de données pour aucun gain de
  // temps. On y descend à 400px, l'attente mesurée ne bouge pas.
  var petitEcran = (window.innerWidth || 1440) < 600;
  var margeV = petitEcran ? 400 : 600;
  var margeH = Math.min(800, window.innerWidth || 800);

  var preparation = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        planifier(e.target);
        preparation.unobserve(e.target);
      }
    });
  }, { rootMargin: margeV + 'px ' + margeH + 'px' });

  // L'aperçu, lui, part très en avance : une image pèse quelques dizaines de Ko,
  // là où la vidéo se compte en mégaoctets. À 1500px, elle est déjà peinte quand
  // la section arrive à l'écran, même en défilement rapide.
  var apercu = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        afficherApercu(e.target);
        apercu.unobserve(e.target);
      }
    });
  }, { rootMargin: '1500px 1000px' });

  // Ne joue que ce qui est réellement visible.
  var lecture = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) jouer(e.target);
      else e.target.pause();
    });
  }, { threshold: 0.35 });

  // Pas de cas particulier pour les premières cartes d'un carrousel : si elles
  // sont visibles à l'arrivée, l'observateur se prononce dès le premier rendu.
  // Les charger d'office chargeait aussi les carrousels restés en bas de page.
  videos.forEach(function (v) {
    apercu.observe(v);
    preparation.observe(v);
    lecture.observe(v);
  });

  // Onglet en arrière-plan : rien ne doit tourner.
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) videos.forEach(function (v) { v.pause(); });
  });
})();
